export default __webpack_public_path__ + "24d3c810b82326fbfd138e6ec8d94b9b.png";